module.exports = __webpack_public_path__ + "static/media/pooCoin.909bc976.png";